import React, { createContext, useContext, useEffect, useState } from "react";
import translations from "../i18n";

export const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  // اللغة الافتراضية: en
  const [lang, setLang] = useState(localStorage.getItem("mg_lang") || "en");

  useEffect(() => {
    localStorage.setItem("mg_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const toggleLanguage = () => {
    setLang((prev) => (prev === "ar" ? "en" : "ar"));
  };

  /**
   * دالة الترجمة الموحدة
   * t("key", "default text")
   * - لو فيه ترجمة في i18n.js → تستخدمها
   * - لو ما فيه → ترجع defaultText
   * - لو ما فيه الاثنين → ترجع نفس المفتاح
   */
  const t = (key, defaultText) => {
    const val = translations?.[lang]?.[key];

    if (val !== undefined && val !== null && val !== "") {
      return val;
    }

    if (defaultText !== undefined && defaultText !== null) {
      return defaultText;
    }

    return key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
